export const teacherSettings = {
  settings: "Settings",
  myProfile: "My profile",
  teachers: "Teachers",
  coteachers: "Co-teachers",
  logout: "Logout",
  cleverLogoutTitle: "Logout from Clever",
  cleverLogoutMessage:
    "You are currently logged in through Clever. To completely sign out, you will also need to log out from your Clever account.",
  teachHubLogoutTitle: "Logout from TeachHub",
  teachHubLogoutMessage:
    "You are currently logged in through TeachHub. To completely sign out, you will also need to log out from your TeachHub account.",
  classLinkLogoutTitle: "Logout from ClassLink",
  classLinkLogoutMessage:
    "You are currently logged in through ClassLink. To completely sign out, you will also need to log out from your ClassLink account.",
  continueLogout: "Continue Logout",
  save: "Save",
  general: "General",
  password: "Password",
  picture: "Picture",
  removePicture: "Remove Picture",
  updatePicture: "Update Picture",
  accountDetails: "Account details",
  soundEffects: "Sound effects",
  soundIsOn: "Sound is on",
  soundIsOff: "Sound is off",
  additionalInformation: "Additional information",
  month: "Month",
  day: "Day",
  year: "Year",
  email: "Email address",
  firstName: "First name",
  lastName: "Last name",
  school: "School",
  dateOfBirthOptionalForBirthDaySurprise:
    "Date of birth (optional for birthday surprise)",
  currentPassword: "Current password",
  newPassword: "New password",
  showCurrentPassword: "Show current password",
  hideCurrentPassword: "Hide current password",
  showNewPassword: "Show new password",
  hideNewPassword: "Hide new password",
  forgotYourPassword: "Forgot your password?",
  reset: "Reset",
  updateSucceed: "Your profile has been updated",
  passwordUpdatedSuccessfully: "Password has been updated",
  incorrectCurrentPassword: "Incorrect current password",
  nothingChange: "Nothing change",
  upgradePlan: "Upgrade plan",
  upgradeNow: "Upgrade now",
  bestForTeachersWhoWorkInTeamLearnMoreAboutOurPlan:
    "Best for teachers who work in teams. Learn more about our <Link>paid plans here</Link>",
  manageSubscription: "Manage subscription",
  manageStripeProfile: "Manage stripe profile",
  goToYourSubscriptionProfile:
    "Go to your subscription profile to change your payment profile",
  dangerZone: "Danger zone",
  deleteAccount: "Delete account",
  deleteAccountTitle: "Delete your account",
  deleteAccountDescription:
    "This action is permanent and cannot be undone. All your classes, students, and transaction data will be permanently deleted.",
  deleteAccountConfirmLabel: "Type DELETE to confirm",
  deleteAccountConfirmButton: "Delete account",
  deleteAccountDialogHint:
    "Remember, confirming permanently deletes your account and all data with no way to recover it.",
}
